import gsap from "gsap";

export class Roadmap {
  private element: HTMLElement;
  private items: HTMLDetailsElement[];

  constructor(element: HTMLElement) {
    this.element = element;
    this.items = Array.from(element.querySelectorAll("details"));
    this.init();
  }

  private init(): void {
    this.items.forEach((item) => {
      const summary = item.querySelector("summary");
      const content = item.querySelector(".roadmap__item-content");

      if (!summary || !content) return;

      // Set initial states
      if (!item.hasAttribute("open")) {
        gsap.set(content, { height: 0, overflow: "hidden" });
      } else {
        gsap.set(content, { height: "auto", overflow: "visible" });
      }

      summary.addEventListener("click", (e) => {
        e.preventDefault(); // Prevent default details behavior

        const isOpen = item.hasAttribute("open");

        if (!isOpen) {
          // Opening animation
          item.setAttribute("open", "");

          // Animate content
          gsap.to(content, {
            height: "auto",
            duration: 0.3,
            ease: "power2.inOut",
            onComplete: () => {
              gsap.set(content, { height: "auto", overflow: "visible" });
            },
          });
        } else {
          // Closing animation
          gsap.to(content, {
            height: 0,
            duration: 0.3,
            ease: "power2.inOut",
            onComplete: () => {
              item.removeAttribute("open");
            },
          });
        }
      });
    });
  }
}
